import { formatterNumber } from '@/utils/utils'
const preValue = Math.PI / 180 // 计算弧度专用

export default class Crane {
  infoPlaneWidth = 1024
  infoPlaneHeight = 512
  infoPlaneMaterial = null
  infoPlaneGroup = new THREE.Group() // 信息板
  craneGroup = new THREE.Group() // 整个塔
  armGroup = new THREE.Group() // 大臂
  carGroup = new THREE.Group() // 车子
  lineGroup = new THREE.Group() // 绳子
  laShengGroup = new THREE.Group() // 拉绳票
  diaoGouGroup = new THREE.Group() // 吊钩
  diaozhongGroup = new THREE.Group() // 吊重
  dongRotationGroup = new THREE.Group() // 动臂顶部旋转部分
  craneNameMesh = null // 塔机名字
  craneCameraGroup = new THREE.Group() // 塔机摄像头
  baseMaterial = new THREE.MeshLambertMaterial({color: 0x103b97})
  whiteMaterial = new THREE.MeshLambertMaterial({color: 0x949ba0})
  offlineMaterial = new THREE.MeshLambertMaterial({color: 0x5f5f5f})
  commonLineMaterial = new THREE.LineBasicMaterial({color: 0x616160})
  currentLineMaterial = new THREE.LineBasicMaterial({color: 0xcecccc})
  loader = new THREE.STLLoader()
  meshData = {white: [], base: []} // mesh数据
  bottomEllipseMesh = null // mesh数据
  bottomArmMesh = null // mesh数据
  oldRunData = {} // 存储上一次的数据
  newRunData = {
    rotationStep: 0,
    transAngle: 0,
    radiusStep: 0,
    newRadius: 0,
    heightScaleStep: 0,
    newHeightScale: 0,
    loadVal: 0,
    dirAngleStep: 0,
    transDirAngle: 0
  }

  constructor (scale) {
    this.scale = scale // 模型的缩放尺寸
    this.diZuo = {x: 200 * scale, y: 150 * scale, z: 5 * scale}
    this.biaoZhunJie = {x: 90 * scale, y: 90 * scale, z: 155 * scale}
    this.biaoZhunJie2 = {x: 90 * scale, y: 90 * scale, z: 306 * scale}
    this.biaoZhunJie5 = {x: 90 * scale, y: 90 * scale, z: 756 * scale}
    this.biaoZhunJie10 = {x: 90 * scale, y: 90 * scale, z: 1505 * scale}
    this.craneCenter = {x: 140 * scale, y: 140 * scale, z: 309 * scale}
    this.lianjie = {x: 61 * scale, y: 150 * scale, z: 66 * scale}
    this.houqiao = {x: 61 * scale, y: 66 * scale, z: 50 * scale}
    this.houqiao2 = {x: 61 * scale, y: 66 * scale, z: 114 * scale}
    this.houqiao5 = {x: 61 * scale, y: 66 * scale, z: 276 * scale}
    this.houqiao10 = {x: 61 * scale, y: 66 * scale, z: 546 * scale}
    this.houqiaoWei = {x: 101 * scale, y: 110 * scale, z: 151 * scale}
    this.qianqiao = {x: 61 * scale, y: 66 * scale, z: 100 * scale}
    this.qianqiao2 = {x: 61 * scale, y: 66 * scale, z: 192 * scale}
    this.qianqiao5 = {x: 61 * scale, y: 66 * scale, z: 464 * scale}
    this.qianqiao10 = {x: 61 * scale, y: 66 * scale, z: 924 * scale}
    this.qianqiaoDuan = {x: 61 * scale, y: 86 * scale, z: 100 * scale}
    this.xiaoche = {x: 70 * scale, y: 45 * scale, z: 45 * scale}
    this.diaosheng = {x: 31 * scale, y: 1501 * scale, z: 2.5 * scale}
    this.diaogou = {x: 14 * scale, y: 43 * scale, z: 20 * scale}
    this.diaozhong = {x: 18 * scale, y: 13 * scale, z: 100 * scale}
    this.taMao = {x: 66 * scale, y: 655 * scale, z: 383 * scale}
    this.dongHouQiao = {x: 295 * scale, y: 210 * scale, z: 228 * scale}
    this.dongLianJie = {x: 61 * scale, y: 66 * scale, z: 110 * scale}
    this.dongBiaoZhunJie = {x: 61 * scale, y: 66 * scale, z: 100 * scale}
    this.dongBiaoZhunJie2 = {x: 61 * scale, y: 66 * scale, z: 200 * scale}
    this.dongBiaoZhunJie5 = {x: 61 * scale, y: 66 * scale, z: 500 * scale}
    this.dongBiaoZhunJie10 = {x: 61 * scale, y: 66 * scale, z: 1000 * scale}
    this.dongQianQiaoDuan = {x: 62 * scale, y: 91 * scale, z: 100 * scale}
    this.dongGangSiSheng = {x: 29 * scale, y: 28 * scale, z: 1732 * scale}
    this.dongBiaoZhunJieXie = 69 * scale
    this.dongBiaoZhunJieDiaoX = 24 * scale
    this.dongBiaoZhunJieDiaoY = 30 * scale
    this.dongBiaoZhunJieHeight = 61 * scale
    this.dongBiaoZhunJieDuanWidth = 32 * scale
    this.dongHouQiaoY = 171 * scale - 2.5// 到后桥平台
    this.dongHouQiaoX = 191 * scale + 5// 到动臂连接点
  }

  // 初始化塔机
  async initCrane (config, callback) {
    const {craneId, screenX, screenY, armLength, balanceArmLength, towerHeight, areaList, craneType, name, hasVideo} = config
    const calcBiaoZhunJieHeight = towerHeight - this.diZuo.z - (craneType === 1 ? 0 : this.craneCenter.z)
    const {b10, b5, b2, b1, bExtral} = this.sureBiaoZhunJie(calcBiaoZhunJieHeight)
    const b10height = b10 * this.biaoZhunJie10.z
    const b5height = b5 * this.biaoZhunJie5.z
    const b2height = b2 * this.biaoZhunJie2.z
    const b1height = b1 * this.biaoZhunJie.z
    this.armLength = armLength
    this.areaList = areaList
    this.balanceArmLength = balanceArmLength
    this.craneHeightY = towerHeight
    this.craneId = craneId
    this.aliasName = name
    this.craneType = craneType
    this.hasVideo = hasVideo
    this.specialAngle = Math.asin(45 / armLength)
    this.taMaoHeight = craneType === 2 ? (towerHeight + this.lianjie.x + this.taMao.z) : (craneType === 1 ? (towerHeight + this.dongHouQiao.z + 20) : (towerHeight + this.lianjie.x + 20))
    // 添加底座
    await this.initModelCommon('/static/stl/diZuo.stl').then((mesh) => {
      mesh.position.y = this.diZuo.z
      this.meshData.white.push(mesh)
      this.craneGroup.add(mesh)
    })
    if (b10) {
      await this.initModelCommon('/static/stl/10biaoZhunJie.stl').then((mesh) => {
        mesh.position.y = this.diZuo.z + this.biaoZhunJie10.z / 2
        this.meshData.base.push(mesh)
        this.craneGroup.add(mesh)
        for (let i = 1; i < b10; i++) {
          const newMesh = mesh.clone()
          newMesh.position.y = mesh.position.y + i * this.biaoZhunJie10.z
          this.meshData.base.push(newMesh)
          this.craneGroup.add(newMesh)
        }
      })
    }
    if (b5) {
      await this.initModelCommon('/static/stl/5biaoZhunJie.stl').then((mesh) => {
        mesh.position.y = this.diZuo.z + b10height + this.biaoZhunJie5.z
        this.meshData.base.push(mesh)
        this.craneGroup.add(mesh)
        for (let i = 1; i < b5; i++) {
          const newMesh = mesh.clone()
          newMesh.position.y = mesh.position.y + i * this.biaoZhunJie5.z
          this.meshData.base.push(newMesh)
          this.craneGroup.add(newMesh)
        }
      })
    }
    if (b2) {
      await this.initModelCommon('/static/stl/2biaoZhunJie.stl').then((mesh) => {
        mesh.position.y = this.diZuo.z + b10height + b5height + this.biaoZhunJie2.z
        this.meshData.base.push(mesh)
        this.craneGroup.add(mesh)
        for (let i = 1; i < b2; i++) {
          const newMesh = mesh.clone()
          newMesh.position.y = mesh.position.y + i * this.biaoZhunJie2.z
          this.meshData.base.push(newMesh)
          this.craneGroup.add(newMesh)
        }
      })
    }
    if (b1) {
      await this.initModelCommon('/static/stl/biaoZhunJie.stl').then((mesh) => {
        mesh.position.y = this.diZuo.z + b10height + b5height + b2height + this.biaoZhunJie.z
        this.meshData.base.push(mesh)
        this.craneGroup.add(mesh)
      })
    }
    if (bExtral) {
      await this.initModelCommon('/static/stl/biaoZhunJie.stl').then((mesh) => {
        mesh.position.y = this.diZuo.z + b10height + b5height + b2height + b1height + bExtral
        this.meshData.base.push(mesh)
        this.craneGroup.add(mesh)
      })
    }
    if (craneType !== 1) {
      const {h10, h5, h2, h1, hExtral} = this.surehouQiao(balanceArmLength - this.lianjie.y / 2 - this.houqiaoWei.z)
      const h10height = h10 * this.houqiao10.z
      const h5height = h5 * this.houqiao5.z
      const h2height = h2 * this.houqiao2.z
      const {q10, q5, q2, q1, qExtral} = this.sureQianQiao(armLength - this.lianjie.y / 2 - this.qianqiaoDuan.z)
      const q10height = q10 * this.qianqiao10.z
      const q5height = q5 * this.qianqiao5.z
      const q2height = q2 * this.qianqiao2.z
      const houQiaoWidthX = balanceArmLength - this.houqiaoWei.z
      const qianQiaoWidthX = -armLength + this.qianqiaoDuan.z
      /* 添加转轴 */
      await this.initModelCommon('/static/stl/dingShengTaoJia.stl').then((mesh) => {
        mesh.position.y = this.craneHeightY
        this.meshData.white.push(mesh)
        this.craneGroup.add(mesh)
      })
      /* 添加大臂后桥链接轴 */
      await this.initModelCommon('/static/stl/lianjie.stl').then((mesh) => {
        mesh.geometry.center()
        mesh.rotation.y = Math.PI
        mesh.rotation.z = Math.PI * -0.5
        mesh.position.y = this.craneHeightY + this.lianjie.z / 2
        this.meshData.white.push(mesh)
        this.armGroup.add(mesh)
      })
      /* 添加塔帽 */
      if (craneType === 2) {
        await this.initModelCommon('/static/stl/taMao.stl').then((mesh) => {
          mesh.rotation.z = 0.5 * Math.PI
          mesh.position.y = this.craneHeightY - 15 * this.scale
          mesh.position.x = 75 * this.scale
          this.meshData.white.push(mesh)
          this.armGroup.add(mesh)
        })
      }
      if (h10) {
        await this.initModelCommon('/static/stl/10houQiao.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.craneHeightY + this.houqiao.y / 2
          mesh.position.x = this.lianjie.y / 2 + this.houqiao10.z / 2
          this.meshData.white.push(mesh)
          this.armGroup.add(mesh)
          for (let i = 1; i < h10; i++) {
            const newMesh = mesh.clone()
            newMesh.position.x = mesh.position.x + i * this.houqiao10.z
            this.meshData.white.push(newMesh)
            this.armGroup.add(newMesh)
          }
        })
      }
      if (h5) {
        await this.initModelCommon('/static/stl/5houQiao.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.craneHeightY + this.houqiao.y / 2
          mesh.position.x = this.lianjie.y / 2 + h10height + this.houqiao5.z / 2
          this.meshData.white.push(mesh)
          this.armGroup.add(mesh)
          for (let i = 1; i < h5; i++) {
            const newMesh = mesh.clone()
            newMesh.position.x = mesh.position.x + i * this.houqiao5.z
            this.meshData.white.push(newMesh)
            this.armGroup.add(newMesh)
          }
        })
      }
      if (h2) {
        await this.initModelCommon('/static/stl/2houQiao.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.craneHeightY + this.houqiao.y / 2
          mesh.position.x = this.lianjie.y / 2 + h10height + h5height + this.houqiao2.z / 2
          this.meshData.white.push(mesh)
          this.armGroup.add(mesh)
          for (let i = 1; i < h2; i++) {
            const newMesh = mesh.clone()
            newMesh.position.x = mesh.position.x + i * this.houqiao2.z
            this.meshData.white.push(newMesh)
            this.armGroup.add(newMesh)
          }
        })
      }
      if (h1) {
        await this.initModelCommon('/static/stl/houQiao.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.craneHeightY + this.houqiao.y / 2
          mesh.position.x = this.lianjie.y / 2 + h10height + h5height + h2height + this.houqiao.z / 2
          this.meshData.white.push(mesh)
          this.armGroup.add(mesh)
        })
      }
      if (hExtral) {
        await this.initModelCommon('/static/stl/houQiao.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.craneHeightY + this.houqiao.y / 2
          if (h1) {
            mesh.position.x = this.lianjie.y / 2 + h10height + h5height + h2height + this.houqiao.z / 2 + hExtral
          } else {
            mesh.position.x = this.lianjie.y / 2 + h10height + h5height + h2height - this.houqiao.z / 2 + hExtral
          }
          this.meshData.white.push(mesh)
          this.armGroup.add(mesh)
        })
      }
      /* 添加后桥尾 */
      await this.initModelCommon('/static/stl/houQiaoWei.stl').then((mesh) => {
        mesh.geometry.center()
        mesh.rotation.x = 0
        mesh.rotation.y = Math.PI * 0.5
        mesh.position.y = this.craneHeightY + this.houqiaoWei.y / 2 - 44 * this.scale
        mesh.position.x = houQiaoWidthX + this.houqiaoWei.z / 2
        this.meshData.white.push(mesh)
        this.armGroup.add(mesh)
      })
      if (q10) {
        await this.initModelCommon('/static/stl/10qianQiao.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.craneHeightY + this.qianqiao.y / 2
          mesh.position.x = -this.lianjie.y / 2 - this.qianqiao10.z / 2
          this.meshData.base.push(mesh)
          this.armGroup.add(mesh)
          for (let i = 1; i < q10; i++) {
            const newMesh = mesh.clone()
            newMesh.position.x = mesh.position.x - i * this.qianqiao10.z
            this.meshData.base.push(newMesh)
            this.armGroup.add(newMesh)
          }
        })
      }
      if (q5) {
        await this.initModelCommon('/static/stl/5qianQiao.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.craneHeightY + this.qianqiao.y / 2
          mesh.position.x = -this.lianjie.y / 2 - q10height - this.qianqiao5.z / 2
          this.meshData.base.push(mesh)
          this.armGroup.add(mesh)
          for (let i = 1; i < q5; i++) {
            const newMesh = mesh.clone()
            newMesh.position.x = mesh.position.x - i * this.qianqiao5.z
            this.meshData.base.push(newMesh)
            this.armGroup.add(newMesh)
          }
        })
      }
      if (q2) {
        await this.initModelCommon('/static/stl/2qianQiao.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.craneHeightY + this.qianqiao.y / 2
          mesh.position.x = -this.lianjie.y / 2 - q10height - q5height - this.qianqiao2.z / 2
          this.meshData.base.push(mesh)
          this.armGroup.add(mesh)
          for (let i = 1; i < q2; i++) {
            const newMesh = mesh.clone()
            newMesh.position.x = mesh.position.x - i * this.qianqiao2.z
            this.meshData.base.push(newMesh)
            this.armGroup.add(newMesh)
          }
        })
      }
      if (q1) {
        await this.initModelCommon('/static/stl/qianQiao.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.craneHeightY + this.qianqiao.y / 2
          mesh.position.x = -this.lianjie.y / 2 - q10height - q5height - q2height - this.qianqiao.z / 2
          this.meshData.base.push(mesh)
          this.armGroup.add(mesh)
        })
      }
      if (qExtral) {
        await this.initModelCommon('/static/stl/qianQiao.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.craneHeightY + this.qianqiao.y / 2
          if (q1) {
            mesh.position.x = -this.lianjie.y / 2 - q10height - q5height - q2height - this.qianqiao.z / 2 - qExtral
          } else {
            mesh.position.x = -this.lianjie.y / 2 - q10height - q5height - q2height + this.qianqiao.z / 2 - qExtral
          }
          this.meshData.base.push(mesh)
          this.armGroup.add(mesh)
        })
      }
      /* 添加前桥端 */
      await this.initModelCommon('/static/stl/qianQiaoDuan.stl').then((mesh) => {
        mesh.geometry.center()
        mesh.rotation.x = 0
        mesh.rotation.y = Math.PI * 0.5
        mesh.position.y = this.craneHeightY + this.qianqiaoDuan.y / 2 - 20 * this.scale
        mesh.position.x = qianQiaoWidthX - this.qianqiaoDuan.z / 2
        this.meshData.base.push(mesh)
        this.armGroup.add(mesh)
      })
      /* 添加小车 */
      await this.initModelCommon('/static/stl/xiaoChe.stl').then((mesh) => {
        mesh.geometry.center()
        mesh.rotation.x = 0
        mesh.rotation.x = -Math.PI * 0.5
        mesh.rotation.z = -Math.PI * 0.5
        mesh.position.y = this.craneHeightY - 15 * this.scale
        mesh.position.x = 0
        this.meshData.white.push(mesh)
        this.carGroup.add(mesh)
      })
      /* 添加吊绳 */
      await this.initModelCommon('/static/stl/diaoSheng.stl').then((mesh) => {
        mesh.geometry.center()
        mesh.rotation.x = 0
        mesh.position.y = -this.diaosheng.y / 2
        mesh.position.x = 0
        mesh.rotation.x = Math.PI
        this.meshData.white.push(mesh)
        this.lineGroup.add(mesh)
        this.lineGroup.position.y = this.craneHeightY
        this.lineGroup.scale.set(1, 0, 1)
        this.carGroup.add(this.lineGroup)
      })
      /* 添加吊钩 */
      await this.initModelCommon('/static/stl/diaoGou.stl').then((mesh) => {
        mesh.rotation.x = 0
        mesh.rotation.y = -Math.PI * 0.5
        this.meshData.white.push(mesh)
        this.diaoGouGroup.add(mesh)
        this.diaoGouGroup.position.y = this.craneHeightY - this.xiaoche.y / 2 - this.diaogou.y / 2
        this.diaoGouGroup.position.x = this.xiaoche.y / 2 - this.diaogou.z / 2 - 3 * this.scale
        this.carGroup.add(this.diaoGouGroup)
      })
      /* 添加吊重 */
      await this.initModelCommon('/static/stl/diaozhong.stl').then((mesh) => {
        mesh.rotation.x = 0
        mesh.rotation.z = -Math.PI * 0.5
        mesh.scale.set(this.scale * 3, this.scale * 3, this.scale * 3)
        mesh.position.z = -this.diaozhong.z * 3 / 2
        mesh.position.x = 0
        this.meshData.white.push(mesh)
        this.diaozhongGroup.add(mesh)
        this.diaozhongGroup.position.y = this.craneHeightY - this.xiaoche.y - this.diaogou.y - this.diaozhong.y / 2 - 15 * this.scale
        this.carGroup.add(this.diaozhongGroup)
      })
      // 添加底部圆
      await this.addEllipse().then((mesh) => {
        this.bottomEllipseMesh = mesh
        this.armGroup.add(mesh)
      })
      // 绘制底部大臂
      await this.addArm().then((mesh) => {
        this.bottomArmMesh = mesh
        this.armGroup.add(mesh)
      })
      // 小车在地面的投影
      await this.addCircle().then((group) => {
        this.carGroup.add(group)
      })
      this.carGroup.position.x = -100 // 小车的初始位置
      this.armGroup.add(this.carGroup)
      this.armGroup.rotation.y = Math.PI * 1.5
      this.craneGroup.add(this.armGroup)
      this.oldRunData = {rotationAngle: 0, dirAngle: 0, radius: -100, height: 0, isOnline: false, loadValue: 0}
    } else {
      const {q10, q5, q2, q1, qExtral} = this.sureDongQianQiao(armLength - this.dongLianJie.z - this.dongQianQiaoDuan.z)
      const q10height = q10 * this.dongBiaoZhunJie10.z
      const q5height = q5 * this.dongBiaoZhunJie5.z
      const q2height = q2 * this.dongBiaoZhunJie2.z
      const qianQiaoWidthX = armLength - this.dongQianQiaoDuan.z + this.dongLianJie.z + 2 - this.dongLianJie.z / 2
      // 后桥部分 + 动臂活动销轴部分， 总的长度是：从拉绳起点的地面投影点到拉绳的末端的投影点
      const armAndExtral = this.dongHouQiaoX + armLength - this.dongBiaoZhunJieDuanWidth
      // 拉绳起点到后桥平面的距离， 总的长度是：拉绳起点到后桥平面的距离减去标准姐的高
      const yAndExtral = this.dongHouQiaoY - this.dongBiaoZhunJieHeight
      /* 添加动臂后桥 */
      await this.initModelCommon('/static/stl/dongHouQiao.stl').then((mesh) => {
        mesh.geometry.center()
        mesh.rotation.x = -0.5 * Math.PI
        mesh.position.y = this.craneHeightY + this.dongHouQiao.y / 2 + 2
        mesh.position.z = 8.5
        mesh.position.x = -15
        this.meshData.white.push(mesh)
        this.dongRotationGroup.add(mesh)
      })
      const lianJiePosition = this.dongLianJie.z + 2 - this.dongLianJie.z / 2
      this.armGroup.position.set(lianJiePosition + 1, this.craneHeightY + 20 - this.dongBiaoZhunJie.y / 2, 0)
      /* 添加动臂前桥连接点 */
      await this.initModelCommon('/static/stl/dongLianJie.stl').then((mesh) => {
        mesh.geometry.center()
        mesh.rotation.x = 0.5 * Math.PI
        mesh.rotation.z = -0.5 * Math.PI
        mesh.rotation.y = 0.5 * Math.PI
        this.armGroup.add(mesh)
        mesh.position.x = this.dongLianJie.z / 2 - 1
        mesh.position.y = this.dongBiaoZhunJie.y / 2 - 0.5
        mesh.position.z = -0.6
        this.meshData.base.push(mesh)
      })
      /* 添加动臂标准节 */
      if (q10) {
        await this.initModelCommon('/static/stl/dongBiaoZhunJie10.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = 0.5 * Math.PI
          mesh.position.y = this.dongBiaoZhunJie.y / 2 - 0.5
          mesh.position.x = this.dongLianJie.z + this.dongBiaoZhunJie10.z / 2 - 1
          mesh.position.z = -0.6
          this.meshData.base.push(mesh)
          this.armGroup.add(mesh)
          for (let i = 1; i < q10; i++) {
            const newMesh = mesh.clone()
            newMesh.position.x = mesh.position.x + i * this.dongBiaoZhunJie10.z
            this.meshData.base.push(newMesh)
            this.armGroup.add(newMesh)
          }
        })
      }
      if (q5) {
        await this.initModelCommon('/static/stl/dongBiaoZhunJie5.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.dongBiaoZhunJie.y / 2 - 0.5
          mesh.position.x = this.dongLianJie.z + q10height + this.dongBiaoZhunJie5.z / 2 - 1
          mesh.position.z = -0.6
          this.meshData.base.push(mesh)
          this.armGroup.add(mesh)
          for (let i = 1; i < q5; i++) {
            const newMesh = mesh.clone()
            newMesh.position.x = mesh.position.x + i * this.dongBiaoZhunJie5.z
            this.meshData.base.push(newMesh)
            this.armGroup.add(newMesh)
          }
        })
      }
      if (q2) {
        await this.initModelCommon('/static/stl/dongBiaoZhunJie2.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.dongBiaoZhunJie.y / 2 - 0.5
          mesh.position.x = this.dongLianJie.z + q10height + q5height + this.dongBiaoZhunJie2.z / 2 - 1
          mesh.position.z = -0.6
          this.meshData.base.push(mesh)
          this.armGroup.add(mesh)
          for (let i = 1; i < q2; i++) {
            const newMesh = mesh.clone()
            newMesh.position.x = mesh.position.x + i * this.dongBiaoZhunJie2.z
            this.meshData.base.push(newMesh)
            this.armGroup.add(newMesh)
          }
        })
      }
      if (q1) {
        await this.initModelCommon('/static/stl/dongBiaoZhunJie.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.dongBiaoZhunJie.y / 2 - 0.5
          mesh.position.x = this.dongLianJie.z + q10height + q5height + q2height + this.dongBiaoZhunJie.z / 2 - 1
          mesh.position.z = -0.6
          this.meshData.base.push(mesh)
          this.armGroup.add(mesh)
        })
      }
      if (qExtral) {
        await this.initModelCommon('/static/stl/dongBiaoZhunJie.stl').then((mesh) => {
          mesh.geometry.center()
          mesh.rotation.x = 0
          mesh.rotation.y = Math.PI * 0.5
          mesh.position.y = this.dongBiaoZhunJie.y / 2 - 0.5
          mesh.position.z = -0.6
          if (q1) {
            mesh.position.x = this.dongLianJie.z + q10height + q5height + q2height + this.dongBiaoZhunJie.z / 2 + qExtral - 1
          } else {
            mesh.position.x = this.dongLianJie.z + q10height + q5height + q2height - this.dongBiaoZhunJie.z / 2 + qExtral - 1
          }
          this.meshData.base.push(mesh)
          this.armGroup.add(mesh)
        })
      }
      /* 添加动臂前桥端 */
      await this.initModelCommon('/static/stl/dongQianQiaoDuan.stl').then((mesh) => {
        mesh.geometry.center()
        mesh.rotation.x = 0
        mesh.rotation.y = -0.5 * Math.PI
        mesh.position.y = this.dongBiaoZhunJie.y / 2 - 3.6
        mesh.position.x = qianQiaoWidthX + this.dongQianQiaoDuan.z / 2 - lianJiePosition - 1
        mesh.position.z = -0.6
        this.meshData.base.push(mesh)
        this.armGroup.add(mesh)
      })
      /* 添加钢丝绳 */
      await this.initModelCommon('/static/stl/gangSiSheng.stl').then((mesh) => {
        mesh.geometry.center()
        mesh.rotation.y = -0.5 * Math.PI
        mesh.rotation.z = -0.5 * Math.PI
        this.laShengGroup.position.set(-36, this.craneHeightY + this.dongHouQiao.y + this.dongGangSiSheng.x / 2 - 4, 0)
        this.laShengGroup.add(mesh)
        mesh.position.z = -0.5
        mesh.position.x = this.dongGangSiSheng.z / 2 - 3
        const len = Math.sqrt(armAndExtral * armAndExtral + yAndExtral * yAndExtral)
        const scale = len / this.dongGangSiSheng.z
        const initAngle = Math.atan(armAndExtral / yAndExtral)
        this.laShengGroup.rotation.z = -(Math.PI * 0.5 - initAngle)
        this.laShengGroup.scale.set(scale, 1, 1)
        this.meshData.white.push(mesh)
        this.dongRotationGroup.add(this.laShengGroup)
      })
      /* 添加吊绳 */
      await this.initModelCommon('/static/stl/diaoSheng.stl').then((mesh) => {
        mesh.geometry.center()
        mesh.rotation.x = 0
        mesh.position.y = -this.diaosheng.y / 2
        mesh.position.x = armLength + 13
        mesh.rotation.x = Math.PI
        mesh.position.z = -0.5
        this.meshData.white.push(mesh)
        this.lineGroup.add(mesh)
        this.lineGroup.position.y = this.craneHeightY + 10
        this.lineGroup.scale.set(1, 0, 1)
        this.dongRotationGroup.add(this.lineGroup)
      })
      /* 添加吊钩 */
      await this.initModelCommon('/static/stl/diaoGou.stl').then((mesh) => {
        mesh.rotation.x = 0
        mesh.rotation.y = -Math.PI * 0.5
        mesh.position.y = this.craneHeightY + 10 - this.diaogou.y / 2
        mesh.position.x = armLength + 13 + this.diaogou.z / 2
        mesh.position.z = -0.5
        this.meshData.white.push(mesh)
        this.diaoGouGroup.add(mesh)
        this.dongRotationGroup.add(this.diaoGouGroup)
      })
      /* 添加吊重 */
      await this.initModelCommon('/static/stl/diaozhong.stl').then((mesh) => {
        mesh.rotation.x = 0
        mesh.rotation.z = -Math.PI * 0.5
        mesh.scale.set(this.scale * 3, this.scale * 3, this.scale * 3)
        mesh.position.z = -this.diaozhong.z * 3 / 2
        mesh.position.x = 0
        mesh.position.y = this.craneHeightY - this.diaogou.y - this.diaozhong.y / 2 + 1
        mesh.position.x = armLength + 10 + this.diaogou.z / 2
        this.meshData.white.push(mesh)
        this.diaozhongGroup.add(mesh)
        this.dongRotationGroup.add(this.diaozhongGroup)
      })
      // 添加底部圆
      await this.addEllipse().then((mesh) => {
        this.bottomEllipseMesh = mesh
        this.craneGroup.add(this.bottomEllipseMesh)
      })
      // 绘制底部大臂
      await this.addArm().then((mesh) => {
        mesh.rotation.y = Math.PI
        this.bottomArmMesh = mesh
        this.dongRotationGroup.add(mesh)
      })
      // 小车在地面的投影
      await this.addCircle().then((mesh) => {
        this.carGroup.add(mesh)
        this.carGroup.position.x = armLength
        this.dongRotationGroup.add(this.carGroup)
      })
      this.dongRotationGroup.add(this.armGroup)
      this.dongRotationGroup.rotation.y = Math.PI * 0.5
      this.craneGroup.add(this.dongRotationGroup)
      this.oldRunData = {rotationAngle: 0, dirAngle: 0, radius: armLength, height: 0, isOnline: false, loadValue: 0}
    }
    // 添加名字
    await this.addName().then((mesh) => {
      mesh.name = this.craneId
      this.craneNameMesh = mesh
      this.craneNameMesh.position.y = this.taMaoHeight + 10
      this.craneGroup.add(this.craneNameMesh)
    })
    // 添加摄像头
    await this.addCamera().then((mesh) => {
      mesh.name = this.craneId
      mesh.position.x = 100
      this.craneCameraGroup.add(mesh)
      this.craneCameraGroup.position.y = this.taMaoHeight + 30
      this.craneCameraGroup.rotation.y = 0.5 * Math.PI
      this.craneCameraGroup.visible = false
      this.craneGroup.add(this.craneCameraGroup)
    })
    // 添加信息板
    await this.addInfoPlane().then((mesh) => {
      mesh.name = this.craneId
      this.infoPlaneGroup.add(mesh)
      this.infoPlaneGroup.visible = false
      this.craneGroup.add(this.infoPlaneGroup)
    })
    // 添加区域
    await this.addArea().then((group) => {
      this.craneGroup.add(group)
    })
    this.craneGroup.position.set(screenX, 0, screenY)
    this.animate()
    callback()
  }

  // 初始化模块
  initModelCommon (url) {
    const self = this
    return new Promise((resolve, reject) => {
      self.loader.load(url, function (geometry) {
        // geometry.computeBoundingBox()
        // console.log(geometry.boundingBox)
        let mesh = new THREE.Mesh(geometry, self.offlineMaterial)
        mesh.name = self.craneId
        mesh.scale.set(self.scale, self.scale, self.scale)
        mesh.rotation.x = 0.5 * Math.PI
        resolve(mesh)
      })
    })
  }

  // 添加底部圆
  addEllipse () {
    const self = this
    return new Promise((resolve, reject) => {
      const ellipseCurve = new THREE.EllipseCurve(
        0, 0,
        self.armLength, self.armLength,
        0, 2 * Math.PI,
        false,
        0
      )
      const points = ellipseCurve.getPoints(70)
      const ellipseGeometry = new THREE.BufferGeometry().setFromPoints(points)
      const ellipseMaterial = new THREE.LineBasicMaterial({color: 0x616160})
      const ellipse = new THREE.Line(ellipseGeometry, ellipseMaterial)
      ellipse.rotation.x = 0.5 * Math.PI
      resolve(ellipse)
    })
  }

  // 绘制底部大臂
  addArm () {
    const self = this
    return new Promise((resolve, reject) => {
      const armGeometry = new THREE.Geometry()
      const p1 = new THREE.Vector3(self.balanceArmLength, 0, 0)
      const p2 = new THREE.Vector3(-self.armLength, 0, 0)
      armGeometry.vertices.push(p1, p2)
      const armMaterial = new THREE.LineBasicMaterial({color: 0x787877})
      const line = new THREE.Line(armGeometry, armMaterial)
      resolve(line)
    })
  }

  // 小车在地面的投影
  addCircle () {
    return new Promise((resolve, reject) => {
      const circleGeometry = new THREE.CircleGeometry(7, 32)
      const circleMaterial = new THREE.MeshBasicMaterial({color: 0xfd0208, side: THREE.DoubleSide})
      const circle = new THREE.Mesh(circleGeometry, circleMaterial)
      circle.rotation.x = 0.5 * Math.PI
      circle.position.y = 2
      circle.position.x = 0
      resolve(circle)
    })
  }

  // 添加区域
  addArea () {
    const self = this
    return new Promise((resolve, reject) => {
      const group = new THREE.Group()
      group.matrixAutoUpdate = false
      self.areaList.forEach((res) => {
        const {inOrOut, pointVoList} = res
        const areaShape = new THREE.Shape()
        const firstItem = pointVoList[0]
        const lastItem = pointVoList[pointVoList.length - 1]
        pointVoList.forEach((point, index) => {
          const {x, y} = point
          if (!index) {
            areaShape.moveTo(x, y)
          } else {
            areaShape.lineTo(x, y)
          }
        })
        if (!inOrOut) { // 外区域
          const beginRad = this.calcRad(firstItem)
          const endRad = this.calcRad(lastItem)
          // 开始弧度+1求出相交点
          const plusY = Math.sin(beginRad + preValue) * self.armLength
          const plusX = Math.cos(beginRad + preValue) * self.armLength
          const plusCood = {x: plusX, y: plusY}
          let num = 0
          for (let i = 0; i < pointVoList.length - 1; i++) {
            if (this.calcLineCross(pointVoList[i], pointVoList[i + 1], {x: 0, y: 0}, plusCood)) {
              num++
            }
          }
          if (num % 2) {
            areaShape.absarc(0, 0, self.armLength, endRad, beginRad, true) // 逆时针
          } else {
            areaShape.absarc(0, 0, self.armLength, endRad, beginRad) // 顺时针
          }
        }
        const geometry = new THREE.ShapeGeometry(areaShape)
        const material = new THREE.MeshBasicMaterial({color: 0x424241, side: THREE.DoubleSide})
        material.transparent = true
        material.opacity = 0.5
        const mesh = new THREE.Mesh(geometry, material)
        mesh.rotation.x = 0.5 * Math.PI
        group.add(mesh)
      })
      resolve(group)
    })
  }
  // 添加塔机名字
  addName () {
    return new Promise((resolve, reject) => {
      const ctx = document.createElement('canvas').getContext('2d')
      ctx.canvas.width = 256
      ctx.canvas.height = 256
      ctx.fillStyle = '#ffffff'
      ctx.font = 'bold 90px arial'
      ctx.textAlign = 'center'
      ctx.fillText(this.aliasName, 128, 128)
      const texture = new THREE.CanvasTexture(ctx.canvas)
      const nameMaterial = new THREE.MeshLambertMaterial({
        map: texture,
        transparent: true
      })
      let geometryPlane = new THREE.PlaneGeometry(128, 128)
      const mesh = new THREE.Mesh(geometryPlane, nameMaterial)
      resolve(mesh)
    })
  }
  // 添加摄像头图标
  addCamera () {
    return new Promise((resolve, reject) => {
      this.addCameraImage().then((canvas) => {
        const texture = new THREE.CanvasTexture(canvas)
        texture.needsUpdate = true
        this.infoPlaneMaterial = new THREE.MeshLambertMaterial({
          map: texture,
          side: THREE.DoubleSide,
          transparent: true
        })
        let geometryPlane = new THREE.PlaneGeometry(50, 50)
        const mesh = new THREE.Mesh(geometryPlane, this.infoPlaneMaterial)
        resolve(mesh)
      })
    })
  }
  async addCameraImage () {
    const ctx = document.createElement('canvas').getContext('2d')
    ctx.canvas.width = 128
    ctx.canvas.height = 128
    const infoPlaneUrl = '/static/img/camera.png'
    await this.addImage(ctx, infoPlaneUrl, [0, 0, 128, 128])
    return ctx.canvas
  }
  // 添加信息板
  addInfoPlane () {
    return new Promise((resolve, reject) => {
      this.showText().then((canvas) => {
        const texture = new THREE.CanvasTexture(canvas)
        texture.needsUpdate = true
        this.infoPlaneMaterial = new THREE.MeshLambertMaterial({
          map: texture,
          side: THREE.DoubleSide,
          transparent: true
        })
        let geometryPlane = new THREE.PlaneGeometry(768, 384)
        const mesh = new THREE.Mesh(geometryPlane, this.infoPlaneMaterial)
        mesh.position.y = this.taMaoHeight + 100
        resolve(mesh)
      })
    })
  }
  async showText (obj = {}) {
    let {radius = 0, height = 0, rotationAngle = 0, windSpeed = 0, loadValue = 0, percent = 0, safeLoad = 0, sensorAlarm = 0, recordTime = '', content = {}} = obj
    const {alarm = [], peccancy = []} = content
    radius = formatterNumber(radius)
    height = formatterNumber(height)
    rotationAngle = formatterNumber(rotationAngle)
    windSpeed = formatterNumber(windSpeed)
    loadValue = formatterNumber(loadValue, 2)
    percent = formatterNumber(percent)
    safeLoad = formatterNumber(safeLoad)
    sensorAlarm = !(sensorAlarm & 0x40) ? '开' : '关'
    const ctx = document.createElement('canvas').getContext('2d')
    ctx.canvas.width = this.infoPlaneWidth
    ctx.canvas.height = this.infoPlaneHeight
    let offset = 0
    if (alarm.length || peccancy.length) {
      const infoPlaneUrl = '/static/img/infoPlane2.png'
      await this.addImage(ctx, infoPlaneUrl, [0, 0, 1000, 400])
    } else {
      offset = 112
      const infoPlaneUrl = '/static/img/infoPlane1.png'
      await this.addImage(ctx, infoPlaneUrl, [offset, 0, 800, 400])
    }
    const radiusUrl = '/static/img/tubiao-radius.png'
    await this.addImage(ctx, radiusUrl, [offset + 30, 50, 50, 50])
    const rotationUrl = '/static/img/tubiao-huizhuan.png'
    await this.addImage(ctx, rotationUrl, [offset + 30, 160, 50, 50])
    const diaogouUrl = '/static/img/tubiao-diaogou.png'
    await this.addImage(ctx, diaogouUrl, [offset + 30, 270, 50, 50])
    const loadUrl = '/static/img/tubiao-load.png'
    await this.addImage(ctx, loadUrl, [offset + 230, 50, 50, 50])
    const lijuUrl = '/static/img/tubiao-liju.png'
    await this.addImage(ctx, lijuUrl, [offset + 230, 160, 50, 50])
    const safeLoadUrl = '/static/img/tubiao-safeLoad.png'
    await this.addImage(ctx, safeLoadUrl, [offset + 230, 270, 50, 50])
    const windUrl = '/static/img/tubiao-wind.png'
    await this.addImage(ctx, windUrl, [offset + 430, 50, 50, 50])
    const bypassUrl = '/static/img/tubiao-bypass.png'
    await this.addImage(ctx, bypassUrl, [offset + 430, 160, 50, 50])
    const workTimeUrl = '/static/img/tubiao-workTime.png'
    await this.addImage(ctx, workTimeUrl, [offset + 430, 270, 50, 50])
    if (alarm.length || peccancy.length) {
      const warningUrl = '/static/img/warning.png'
      await this.addImage(ctx, warningUrl, [offset + 690, 40, 60, 60])
    }
    // 标题
    ctx.fillStyle = '#cacaca'
    ctx.font = 'normal 20px arial'
    ctx.fillText(`幅度 m`, offset + 100, 62)
    ctx.fillText(`回转 °`, offset + 100, 170)
    ctx.fillText(`吊钩 m`, offset + 100, 280)
    ctx.fillText(`吊重 t`, offset + 300, 62)
    ctx.fillText(`力矩比 %`, offset + 300, 170)
    ctx.fillText(`安全吊重 t`, offset + 300, 280)
    ctx.fillText(`风速 m/s`, offset + 500, 62)
    ctx.fillText(`Bypass`, offset + 500, 170)
    ctx.fillText(`运行时间`, offset + 500, 280)
    ctx.fillStyle = '#49d5f3'
    ctx.font = 'bold 27px arial'
    ctx.fillText(radius, offset + 100, 102)
    ctx.fillText(rotationAngle, offset + 100, 210)
    ctx.fillText(height, offset + 100, 320)
    ctx.fillText(loadValue, offset + 300, 102)
    ctx.fillText(percent, offset + 300, 210)
    ctx.fillText(safeLoad, offset + 300, 320)
    ctx.fillText(windSpeed, offset + 500, 102)
    ctx.fillText(sensorAlarm, offset + 500, 210)
    ctx.fillText(recordTime, offset + 500, 320)
    ctx.fillStyle = '#f9da02'
    ctx.font = 'bold 25px arial'
    alarm.forEach((item, index) => {
      const y = 50 * index + 90
      ctx.fillText(item, offset + 780, y)
    })
    const len = alarm.length
    ctx.fillStyle = '#fb0505'
    peccancy.forEach((item, index) => {
      const y = 50 * (index + len) + 90
      ctx.fillText(item, offset + 780, y)
    })
    return ctx.canvas
  }
  // 添加背景板
  addImage (ctx, url, cord) {
    return new Promise((resolve, reject) => {
      const image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.src = url
      image.onload = function () {
        ctx.drawImage(image, ...cord)
        resolve()
      }
    })
  }
  updateInfoPlane (obj) {
    this.showText(obj).then((canvas) => {
      const texture = new THREE.CanvasTexture(canvas)
      texture.needsUpdate = true
      if (this.infoPlaneMaterial) this.infoPlaneMaterial.map = texture
    })
  }
  // 处理实时数据
  update ({rotationAngle, dirAngle, orgRadius, radius, orgHeight, height, loadValue, windSpeed, percent, safeLoad, sensorAlarm, recordTime, isOnline, alarm, peccancy, isCurrentProjectCrane}) {
    const speed = 300
    // 此处对于回转有两个作用 1. 去除多增加的360° 2. 将负值转化为正值
    if (this.craneGroup !== 1) {
      const positionY = this.armGroup.rotation.y
      this.armGroup.rotation.y = positionY % (Math.PI * 2)
      if (positionY < 0) {
        this.armGroup.rotation.y = (Math.PI * 2) + positionY
      }
    } else {
      const positionY = this.dongRotationGroup.rotation.y
      this.dongRotationGroup.rotation.y = positionY % (Math.PI * 2)
      if (positionY < 0) {
        this.dongRotationGroup.rotation.y = (Math.PI * 2) + positionY
      }
    }
    // 处理回转
    let oldAngle = this.resolveAngle(this.oldRunData.rotationAngle)
    let newAngle = this.resolveAngle(rotationAngle)
    if (Math.abs(newAngle - oldAngle) > 180) { // 假如超过180度，走小角
      if (newAngle > oldAngle) {
        newAngle -= 360
      } else {
        newAngle += 360
      }
    }
    let oldTransAngle = oldAngle * preValue
    let transAngle = newAngle * preValue
    const rotationStep = (transAngle - oldTransAngle) / speed
    // 处理幅度
    const oldRadius = this.oldRunData.radius
    const newRadius = this.craneType !== 1 ? -radius : radius
    const radiusStep = (newRadius - oldRadius) / speed
    // 处理吊绳
    const diaoShengHeight = this.diaosheng.y
    const oldHeightScale = this.oldRunData.height
    const newHeightScale = height / diaoShengHeight
    const heightScaleStep = (newHeightScale - oldHeightScale) / speed
    this.newRunData = {rotationStep, transAngle, radiusStep, newRadius, heightScaleStep, newHeightScale, loadValue}
    if (this.craneType === 1) {
      // 处理仰角
      const {dirAngle: oldDirAngle} = this.oldRunData
      const transOldAngle = oldDirAngle * preValue
      const transNewAngle = dirAngle * preValue
      const dirAngleStep = (transNewAngle - transOldAngle) / speed
      this.newRunData = {...this.newRunData, ...{dirAngleStep, transDirAngle: transNewAngle}}
    }
    // 处理上下线
    const oldOnline = this.oldRunData.isOnline
    if (oldOnline !== isOnline) {
      const {white, base} = this.meshData
      if (isOnline) {
        this.craneNameMesh.position.y = this.taMaoHeight + 284 + 20
        this.craneCameraGroup.position.y = this.taMaoHeight + 284 + 40
        this.infoPlaneGroup.visible = true
        this.craneCameraGroup.visible = this.hasVideo
        white.forEach((res) => {
          res.material = this.whiteMaterial
        })
        base.forEach((res) => {
          res.material = this.baseMaterial
        })
      } else {
        this.infoPlaneGroup.visible = false
        this.craneCameraGroup.visible = false
        this.craneNameMesh.position.y = this.taMaoHeight + 10
        this.craneCameraGroup.position.y = this.taMaoHeight + 30
        white.forEach((res) => {
          res.material = this.offlineMaterial
        })
        base.forEach((res) => {
          res.material = this.offlineMaterial
        })
      }
    }
    if (isOnline) {
      const content = this.showAlarmInfo({alarm, peccancy})
      this.updateInfoPlane({rotationAngle, radius: orgRadius, height: orgHeight, loadValue, windSpeed, percent, safeLoad, sensorAlarm, recordTime, content})
    }
    if (isCurrentProjectCrane) {
      this.bottomEllipseMesh.material = this.currentLineMaterial
      this.bottomArmMesh.material = this.currentLineMaterial
    } else {
      this.bottomEllipseMesh.material = this.commonLineMaterial
      this.bottomArmMesh.material = this.commonLineMaterial
    }
    this.oldRunData = {
      rotationAngle: rotationAngle,
      radius: newRadius,
      height: newHeightScale,
      isOnline,
      dirAngle
    }
  }
  // 处理角度
  resolveAngle (angle) {
    if (this.craneType !== 1) {
      const transAngle = -angle + 270
      return transAngle > 0 ? transAngle : 360 + transAngle
    } else {
      const transAngle = 90 - angle
      return transAngle > 0 ? transAngle : 360 + transAngle
    }
  }
  // 执行动画
  render () {
    const {rotationStep, transAngle, radiusStep, newRadius, heightScaleStep, newHeightScale, loadValue, dirAngleStep, transDirAngle} = this.newRunData
    let oldScale = this.lineGroup.scale.y
    if (this.craneType !== 1) {
      const oldY = this.armGroup.rotation.y
      const oldRadius = this.carGroup.position.x
      if (rotationStep > 0) {
        if (oldY < transAngle) {
          this.armGroup.rotation.y += rotationStep
        }
      } else {
        if (oldY > transAngle) {
          this.armGroup.rotation.y += rotationStep
        }
      }
      if (radiusStep > 0) {
        if (oldRadius < newRadius) {
          this.carGroup.position.x += radiusStep
        }
      } else {
        if (oldRadius > newRadius) {
          this.carGroup.position.x += radiusStep
        }
      }
      if (heightScaleStep > 0) {
        if (oldScale < newHeightScale) {
          oldScale += heightScaleStep
        }
      } else {
        if (oldScale > newHeightScale) {
          oldScale += heightScaleStep
        }
      }
      this.lineGroup.scale.set(1, oldScale, 1)
      const height = oldScale * this.diaosheng.y
      this.diaoGouGroup.position.y = this.craneHeightY - height
      if (loadValue > 0) {
        this.diaozhongGroup.visible = true
        this.diaozhongGroup.position.y = this.craneHeightY - height - this.diaogou.y - this.diaozhong.y / 2 - 15 * this.scale
      } else {
        this.diaozhongGroup.visible = false
      }
    } else { // 处理动臂
      const oldY = this.dongRotationGroup.rotation.y
      if (rotationStep > 0) {
        if (oldY < transAngle) {
          this.dongRotationGroup.rotation.y += rotationStep
        }
      } else {
        if (oldY > transAngle) {
          this.dongRotationGroup.rotation.y += rotationStep
        }
      }
      const oldRadius = this.carGroup.position.x
      if (radiusStep > 0) {
        if (oldRadius < newRadius) {
          this.carGroup.position.x += radiusStep
        }
      } else {
        if (oldRadius > newRadius) {
          this.carGroup.position.x += radiusStep
        }
      }
      const oldZ = this.armGroup.rotation.z
      if (dirAngleStep > 0) {
        if (oldZ < transDirAngle) {
          this.armGroup.rotation.z += dirAngleStep
        }
      } else {
        if (oldZ > transDirAngle) {
          this.armGroup.rotation.z += dirAngleStep
        }
      }
      const newAngle = this.armGroup.rotation.z
      const lineY = Math.sin(newAngle) * (this.armLength - this.dongBiaoZhunJieDiaoX / 2) + this.craneHeightY + 10
      const lineX = Math.cos(newAngle) * this.armLength + Math.sin(newAngle) * (this.dongBiaoZhunJieDiaoY / 2) - this.armLength
      this.lineGroup.position.set(lineX, lineY, 0)
      const a = this.dongBiaoZhunJieHeight / Math.cos(newAngle)
      const b = Math.tan(newAngle) * this.dongBiaoZhunJieHeight
      const c = Math.sqrt(this.dongBiaoZhunJieXie * this.dongBiaoZhunJieXie - this.dongBiaoZhunJieHeight * this.dongBiaoZhunJieHeight)
      const d = (b + c) * Math.cos(newAngle)
      const e = (b + c) * Math.sin(newAngle)
      const f = this.armLength * Math.sin(newAngle)
      const g = this.armLength * Math.cos(newAngle)
      const newX = g - d + this.dongHouQiaoX
      if (newAngle > this.specialAngle) {
        const newY = (f - e + a) - this.dongHouQiaoY
        const disXie = Math.sqrt(newX * newX + newY * newY)
        const scale = disXie / this.dongGangSiSheng.z
        const angle = Math.atan(newY / newX)
        this.laShengGroup.rotation.z = angle
        this.laShengGroup.scale.set(scale, 1, 1)
      } else {
        const newY = this.dongHouQiaoY - (f - e + a)
        const disXie = Math.sqrt(newX * newX + newY * newY)
        const scale = disXie / this.dongGangSiSheng.z
        const angle = Math.atan(newY / newX)
        this.laShengGroup.rotation.z = -angle
        this.laShengGroup.scale.set(scale, 1, 1)
      }
      if (heightScaleStep > 0) {
        if (oldScale < newHeightScale) {
          oldScale += heightScaleStep
        }
      } else {
        if (oldScale > newHeightScale) {
          oldScale += heightScaleStep
        }
      }
      this.lineGroup.scale.set(1, oldScale, 1)
      const height = oldScale * this.diaosheng.y
      this.diaoGouGroup.position.y = (lineY - this.craneHeightY - 10) - (height - this.diaogou.y / 2)
      this.diaoGouGroup.position.x = lineX
      if (loadValue > 0) {
        this.diaozhongGroup.visible = true
        this.diaozhongGroup.position.y = (lineY - this.craneHeightY - 10) - (height - this.diaogou.y - this.diaozhong.y / 2 + 7)
        this.diaozhongGroup.position.x = lineX
      } else {
        this.diaozhongGroup.visible = false
      }
    }
  }

  /* 添加动画 */
  animate () {
    this.render()
    requestAnimationFrame(this.animate.bind(this))
  }

  // 判断采用2、5、10
  sureBiaoZhunJie (total) {
    const b10 = parseInt(total / this.biaoZhunJie10.z) // 10标准节有几个
    const b5 = parseInt((total - b10 * this.biaoZhunJie10.z) / this.biaoZhunJie5.z)
    const b2 = parseInt((total - b10 * this.biaoZhunJie10.z - b5 * this.biaoZhunJie5.z) / this.biaoZhunJie2.z)
    const b1 = parseInt((total - b10 * this.biaoZhunJie10.z - b5 * this.biaoZhunJie5.z - b2 * this.biaoZhunJie2.z) / this.biaoZhunJie.z)
    const bExtral = total - b10 * this.biaoZhunJie10.z - b5 * this.biaoZhunJie5.z - b2 * this.biaoZhunJie2.z - b1 * this.biaoZhunJie.z
    return {b10, b5, b2, b1, bExtral}
  }

  surehouQiao (total) {
    const h10 = parseInt(total / this.houqiao10.z) // 10标准节有几个
    const h5 = parseInt((total - h10 * this.houqiao10.z) / this.houqiao5.z)
    const h2 = parseInt((total - h10 * this.houqiao10.z - h5 * this.houqiao5.z) / this.houqiao2.z)
    const h1 = parseInt((total - h10 * this.houqiao10.z - h5 * this.houqiao5.z - h2 * this.houqiao2.z) / this.houqiao.z)
    const hExtral = total - h10 * this.houqiao10.z - h5 * this.houqiao5.z - h2 * this.houqiao2.z - h1 * this.houqiao.z
    return {h10, h5, h2, h1, hExtral}
  }

  sureQianQiao (total) {
    const q10 = parseInt(total / this.qianqiao10.z) // 10标准节有几个
    const q5 = parseInt((total - q10 * this.qianqiao10.z) / this.qianqiao5.z)
    const q2 = parseInt((total - q10 * this.qianqiao10.z - q5 * this.qianqiao5.z) / this.qianqiao2.z)
    const q1 = parseInt((total - q10 * this.qianqiao10.z - q5 * this.qianqiao5.z - q2 * this.qianqiao2.z) / this.qianqiao.z)
    const qExtral = total - q10 * this.qianqiao10.z - q5 * this.qianqiao5.z - q2 * this.qianqiao2.z - q1 * this.qianqiao.z
    return {q10, q5, q2, q1, qExtral}
  }

  sureDongQianQiao (total) {
    const q10 = parseInt(total / this.dongBiaoZhunJie10.z) // 10标准节有几个
    const q5 = parseInt((total - q10 * this.dongBiaoZhunJie10.z) / this.dongBiaoZhunJie5.z)
    const q2 = parseInt((total - q10 * this.dongBiaoZhunJie10.z - q5 * this.dongBiaoZhunJie5.z) / this.dongBiaoZhunJie2.z)
    const q1 = parseInt((total - q10 * this.dongBiaoZhunJie10.z - q5 * this.dongBiaoZhunJie5.z - q2 * this.dongBiaoZhunJie2.z) / this.dongBiaoZhunJie.z)
    const qExtral = total - q10 * this.dongBiaoZhunJie10.z - q5 * this.dongBiaoZhunJie5.z - q2 * this.dongBiaoZhunJie2.z - q1 * this.dongBiaoZhunJie.z
    return {q10, q5, q2, q1, qExtral}
  }

  // 计算弧度
  calcRad (coordinate) {
    const {x, y} = coordinate
    const heightY = Math.abs(y)
    const widthX = Math.abs(x)
    let tan = 0
    // 位于右半圆
    if (x >= 0) {
      if (y > 0) { // 位于右半圆下半圆
        tan = Math.atan(heightY / widthX)
      } else if (y === 0) { // 位于0度位置

      } else { // 位于右半圆上半圆
        tan = preValue * 360 - Math.atan(heightY / widthX)
      }
    } else { // 位于左半圆
      if (y > 0) { // 位于左半圆下半圆
        tan = preValue * 180 - Math.atan(heightY / widthX)
      } else if (y === 0) {
        tan = preValue * 180
      } else { // 位于左半圆上半圆
        tan = Math.atan(heightY / widthX) + preValue * 180
      }
    }
    return tan
  }

  /* 计算是否相交 */
  calcLineCross (a, b, c, d) {
    // 这里利用了向量的知识
    const ab = {x: b.x - a.x, y: b.y - a.y}
    const ac = {x: c.x - a.x, y: c.y - a.y}
    const ad = {x: d.x - a.x, y: d.y - a.y}
    const abxac = (ab.x * ac.y) - (ab.y * ac.x)
    const abxad = (ab.x * ad.y) - (ab.y * ad.x)
    const cd = {x: d.x - c.x, y: d.y - c.y}
    const ca = {x: a.x - c.x, y: a.y - c.y}
    const cb = {x: b.x - c.x, y: b.y - c.y}
    const cdxca = (cd.x * ca.y) - (cd.y * ca.x)
    const cdxcb = (cd.x * cb.y) - (cd.y * cb.x)
    if (abxac * abxad < 0 && cdxca * cdxcb < 0) { // 证明c、d在ab的两侧
      const denominator = (b.y - a.y) * (d.x - c.x) - (a.x - b.x) * (c.y - d.y)
      // 线段所在直线的交点坐标 (x , y)
      // eslint-disable-next-line no-unused-vars
      const x = ((b.x - a.x) * (d.x - c.x) * (c.y - a.y) +
        (b.y - a.y) * (d.x - c.x) * a.x -
        (d.y - c.y) * (b.x - a.x) * c.x) / denominator
      // eslint-disable-next-line no-unused-vars
      const y = -((b.y - a.y) * (d.y - c.y) * (c.x - a.x) +
        (b.x - a.x) * (d.y - c.y) * a.y -
        (d.x - c.x) * (b.y - a.y) * c.y) / denominator
      return true
    }
    return false
  }
  showAlarmInfo ({alarm, peccancy}) {
    const content = {alarm: [], peccancy: []}
    /* 报警信息 */
    const alarmCode = {
      0: '左转-防碰撞',
      1: '右转-防碰撞',
      2: '幅度出-防碰撞',
      3: '幅度进-防碰撞',
      4: '左转-限制区',
      5: '右转-限制区',
      6: '幅度出-限制区',
      7: '幅度进-限制区',
      8: '回转左限位',
      9: '回转右限位',
      10: '幅度出限位',
      11: '幅度进限位',
      12: '高度上限位',
      13: '高度下限位',
      14: '力',
      15: '力矩',
      16: '风速'
    }
    const array = [1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048, 4096, 8192, 16384, 32768, 65536]
    array.forEach((item, index) => {
      if (peccancy & item) {
        const peccancyContent = alarmCode[index]
        content.peccancy.push(peccancyContent)
      } else if (alarm & item) {
        const alarmContent = alarmCode[index]
        content.alarm.push(alarmContent)
      }
    })
    return content
  }
}



// WEBPACK FOOTER //
// ./src/common/Crane.js